import axios from 'axios';
import { getToken } from '../auth/api';
import mime from 'mime';
import { LINK_DATA_KEYS } from './utilsConstants';
import { BOOLEAN_STRINGS_CONSTANTS } from '../constants/constants';

export const UPLOAD_URL = '/storage/v1/upload';

export default (activeOrganizationAccount: string, url: string, file?: File, data?: FormData) => {
    const token = getToken();
    const formData = data ?? new FormData();
    if (file) {
        const ext = file.name.substring(file.name.lastIndexOf('.'));
        const mimeType = mime.getType(ext);

        formData.append('file', new Blob([file], { type: mimeType }), file.name);
    }

    return axios.post(url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
            ownerId: activeOrganizationAccount,
            Authorization: token ? 'Bearer ' + token.token : ''
        }
    });
};

const blobToFile = (theBlob: Blob, fileName: string): File => {
    const b: any = theBlob;
    b.lastModifiedDate = new Date();
    b.name = fileName;
    return theBlob as File;
};

export const createLinkFormData = (linkURL: string, linkName: string): FormData => {
    const formData = new FormData();
    formData.append(LINK_DATA_KEYS.isLink, BOOLEAN_STRINGS_CONSTANTS.true);
    formData.append(LINK_DATA_KEYS.linkURL, linkURL);
    formData.append(LINK_DATA_KEYS.linkName, linkName);

    return formData;
};
